import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anonKey);

export const supabase = isSupabaseConfigured
  ? createClient(url, anonKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;

export const whatsappNumber = import.meta.env.VITE_WHATSAPP_NUMBER || '5581997283255';
export const instagramHandle = import.meta.env.VITE_INSTAGRAM_HANDLE || 'sena_beachway';
export const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sena-beachway-boutique.lovable.app';

export function whatsappUrl(message: string) {
  return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
}
